import { configStore } from "../stores/config";
import { get } from "svelte/store";
import Fooji from '@fooji/microsites'
import en from '../constants/copy.en';

type ErrorSetting = keyof (ReturnType<typeof en>)["error"];

export class ErrorWithSetting extends Error {
  errorSetting: ErrorSetting;
  metadata: Record<string, unknown>;

  constructor(message: string, errorSetting: ErrorSetting = "generic", metadata: Record<string, unknown> = {}) {
    super(message);
    this.errorSetting = errorSetting;
    this.metadata = metadata;
  }
}

const triggerListener = async () => {
  const response = await Fooji.Listener.callOfDutyStart(get(configStore));
  const processKey = response.process_key;

  if (!processKey) {
    throw new Error('No process key returned from internal call of duty listener')
  }

  // TODO: do we need the process key at all?
  return processKey;
}

export const startWorkflow = async () => {
  await triggerListener();
  
  await Fooji.Poller.startPolling((resolve, reject) => {
    return (campaignUser) => {
      const { current_status: currentStatus, metadata } = campaignUser;

      const currentPhaseKey = Object.keys(metadata ?? {}).filter(k => k.startsWith("current_phase_")).sort().reverse()[0];
      const currentPhase = metadata?.[currentPhaseKey] as string;

      if (currentStatus === "finished") {
        if (currentPhase === "thank-you") {
          reject(new ErrorWithSetting("Link used", "alreadyParticipatedToday"));
          return true;
        }
        resolve({ currentPhase, campaignUser });
        return true;
      } else if (currentStatus === "fatal-error") {
        reject(new ErrorWithSetting("Fatal workflow error", "generic", { campaignUser }));
        return true;
      }

      return false;
    }
  });
}